export default "__VITE_ASSET__sC1bSdQr__"